// extracted by mini-css-extract-plugin
export var item = "navigation-item-module--item--dnKQB";
export var link = "navigation-item-module--link--o079g";
export var border = "navigation-item-module--border--xcBH3";
export var userLink = "navigation-item-module--user-link--t0GBs";
export var icon = "navigation-item-module--icon--hUHCX";